module.exports = __webpack_public_path__ + "img/bannerIcon04.0def8136.png";